//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { DateMixin } from '@/mixins/DateMixin';
export default {
  name: 'yearRangeQuarter',
  mixins: [DateMixin],
  mounted: function mounted() {
    this.$emit('change', [this.startYear, this.endYear, this.quarterMonths]);
  },
  methods: {
    // 开始年变化
    handleChange: function handleChange(value) {
      this.startYear = value;
      var startTime = this.startYear;
      var endTime = this.endYear;

      if (startTime >= endTime) {
        this.startYear = '';
        this.$message.error('开始年必须小于结束年');
      }

      if (this.quarterMonths) {
        this.$emit('change', [this.startYear, this.endYear, this.quarterMonths]);
      }
    },
    // 结束年变化
    handleChange2: function handleChange2(value) {
      this.endYear = value;
      var startTime = this.startYear;
      var endTime = this.endYear;

      if (startTime >= endTime) {
        this.endYear = '';
        this.$message.error('开始年必须小于结束年');
      }

      if (this.quarterMonths) {
        this.$emit('change', [this.startYear, this.endYear, this.quarterMonths]);
      }
    },
    // 季度变化
    handleMonthsChange: function handleMonthsChange(value) {
      this.quarterMonths = value;

      if (this.startYear && this.endYear) {
        this.$emit('change', [this.startYear, this.endYear, this.quarterMonths]);
      }
    }
  }
};